export default "__VITE_ASSET__7c6a674c__"